import { ComponentParams } from '@sitecore-jss/sitecore-jss-react';
import { ProductSelectorProps } from '../types/productSelector.types';

export class ProductSelectorModel {
  private readonly params?: ComponentParams;

  constructor(props: ProductSelectorProps) {
    this.params = props?.params;
  }

  get src(): string | undefined {
    return this.params?.src;
  }
}
